
      import { createComponent } from '@lit/react'
      import { type EventName } from '@lit/react'
      import * as React from 'react'

      import Component from '../../components/option-list/option-list.component.js'
      import type { DdsCancelEvent } from '../../events/events'
import type { DdsOptionChangeEvent } from '../../events/events'
import type { DdsKeydownEvent } from '../../events/events'
import type { DdsListChangedEvent } from '../../events/events'
      export type { DdsCancelEvent } from '../../events/events'
export type { DdsOptionChangeEvent } from '../../events/events'
export type { DdsKeydownEvent } from '../../events/events'
export type { DdsListChangedEvent } from '../../events/events'

      const tagName = 'dap-ds-option-list'

      /**
 * `dap-ds-option-list`
 * @summary An option list is a list of selectable options.
 * @element dap-ds-option-list
 * @title - Option list
 *
 * @event {{ void }} dds-cancel - Fired when the escape key is pressed.
 * @event {{ option: DapDSOptionItem, value: string, index: number, text: string }} dds-option-change - Fired when the option list value changes.
 * @event {{ void }} dds-keydown - Fired when a key is pressed down.
 * @event {{ elements: DapDSOptionItem[] }} dds-list-changed - Fired when the available options list changes.
 *
 * @csspart base - The main option list container.
 * @csspart option-item - The option item of the option list.
 * @csspart popup-base - The base of the popup.
 * @csspart option-item-base - The base of the option item.
 * @csspart option-item-label - The label of the option item.
 * @csspart option-item-prefix - The prefix of the option item.
 * @csspart option-item-suffix - The suffix of the option item.
 *
 * @slot - The default slot for the options.
 */
      const reactWrapper = createComponent({
        tagName,
        elementClass: Component,
        react: React,
        events: {
          onDdsCancel: 'dds-cancel' as EventName<DdsCancelEvent>,
onDdsOptionChange: 'dds-option-change' as EventName<DdsOptionChangeEvent>,
onDdsKeydown: 'dds-keydown' as EventName<DdsKeydownEvent>,
onDdsListChanged: 'dds-list-changed' as EventName<DdsListChangedEvent>
        },
        displayName: "DapDSOptionList"
      })

      export default reactWrapper
    